var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 18,
    viewBox: "0 0 25 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_23391_30825)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_23391_30825",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 18
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.619 -2.59355e-08L2.38095 -2.73006e-09C1.06599 -1.22229e-09 -1.36314e-09 1.07452 -3.04465e-09 2.4L-1.97902e-08 15.6C-2.14717e-08 16.9255 1.06599 18 2.38095 18L22.619 18C23.934 18 25 16.9255 25 15.6L25 2.4C25 1.07452 23.934 -2.74433e-08 22.619 -2.59355e-08Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_23391_30825)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.619 -2.59355e-08L2.38095 -2.73006e-09C1.06599 -1.22229e-09 -1.36314e-09 1.07452 -3.04465e-09 2.4L-1.97902e-08 15.6C-2.14717e-08 16.9255 1.06599 18 2.38095 18L22.619 18C23.934 18 25 16.9255 25 15.6L25 2.4C25 1.07452 23.934 -2.74433e-08 22.619 -2.59355e-08Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0L10.7143 -1.22852e-08L10.7143 8.4L-1.06563e-08 8.4L0 0Z",
    fill: "#444379"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.19043 1.19995L1.19043 2.39995L2.38091 2.39995L2.38091 1.19995L1.19043 1.19995ZM3.57138 1.19995L3.57138 2.39995L4.76186 2.39995L4.76186 1.19995L3.57138 1.19995ZM5.95233 1.19995L5.95233 2.39995L7.14281 2.39995L7.14281 1.19995L5.95233 1.19995ZM8.33329 1.19995L8.33329 2.39995L9.52376 2.39995L9.52376 1.19995L8.33329 1.19995ZM7.14281 2.39995L7.14281 3.59995L8.33329 3.59995L8.33329 2.39995L7.14281 2.39995ZM4.76186 2.39995L4.76186 3.59995L5.95233 3.59995L5.95233 2.39995L4.76186 2.39995ZM2.38091 2.39995L2.38091 3.59995L3.57138 3.59995L3.57138 2.39995L2.38091 2.39995ZM1.19043 3.59995L1.19043 4.79995L2.38091 4.79995L2.38091 3.59995L1.19043 3.59995ZM3.57138 3.59995L3.57138 4.79995L4.76186 4.79995L4.76186 3.59995L3.57138 3.59995ZM5.95233 3.59995L5.95233 4.79995L7.14281 4.79995L7.14281 3.59995L5.95233 3.59995ZM8.33329 3.59995L8.33329 4.79995L9.52376 4.79995L9.52376 3.59995L8.33329 3.59995ZM1.19043 5.99995L1.19043 7.19995L2.38091 7.19995L2.38091 5.99995L1.19043 5.99995ZM3.57138 5.99995L3.57138 7.19995L4.76186 7.19995L4.76186 5.99995L3.57138 5.99995ZM5.95233 5.99995L5.95233 7.19995L7.14281 7.19995L7.14281 5.99995L5.95233 5.99995ZM8.33329 5.99995L8.33329 7.19995L9.52376 7.19995L9.52376 5.99995L8.33329 5.99995ZM7.14281 4.79995L7.14281 5.99995L8.33329 5.99995L8.33329 4.79995L7.14281 4.79995ZM4.76186 4.79995L4.76186 5.99995L5.95233 5.99995L5.95233 4.79995L4.76186 4.79995ZM2.38091 4.79995L2.38091 5.99995L3.57138 5.99995L3.57138 4.79995L2.38091 4.79995Z",
    fill: "#A7B6E7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7143 -1.22852e-08L10.7143 1.2L25 1.2L25 -2.86656e-08L10.7143 -1.22852e-08ZM10.7143 2.4L10.7143 3.6L25 3.6L25 2.4L10.7143 2.4ZM10.7143 4.8L10.7143 6L25 6L25 4.8L10.7143 4.8ZM10.7143 7.2L10.7143 8.4L25 8.4L25 7.2L10.7143 7.2ZM-1.21786e-08 9.6L-1.37009e-08 10.8L25 10.8L25 9.6L-1.21786e-08 9.6ZM-1.52232e-08 12L-1.67456e-08 13.2L25 13.2L25 12L-1.52232e-08 12ZM-1.82679e-08 14.4L-1.97902e-08 15.6L25 15.6L25 14.4L-1.82679e-08 14.4ZM-2.13125e-08 16.8L-2.28349e-08 18L25 18L25 16.8L-2.13125e-08 16.8Z",
    fill: "#ED4C49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.619 0.599976L2.38093 0.599976C1.39471 0.599976 0.595215 1.40586 0.595215 2.39998L0.595215 15.6C0.595215 16.5941 1.39471 17.4 2.38093 17.4L22.619 17.4C23.6052 17.4 24.4047 16.5941 24.4047 15.6L24.4047 2.39998C24.4047 1.40586 23.6052 0.599976 22.619 0.599976Z",
    stroke: "black",
    strokeOpacity: 0.1
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_23391_30825"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUs);
export default __webpack_public_path__ + "static/media/US.9dfa86f4da49a9316bfac520bd57f39d.svg";
export { ForwardRef as ReactComponent };